export class Experiments<Specs> {
  private readonly specs: Specs;

  constructor(specs: Specs) {
    this.specs = specs;
  }

  is<T extends keyof Specs>(key: T, value: Specs[T]) {
    return this.specs[key] === value;
  }

  get(): Specs {
    return this.specs;
  }

  getSpec<T extends keyof Specs>(key: T) {
    return this.specs[key];
  }
}
